import { Fade } from "@material-ui/core";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import * as React from "react";

interface Props {
  showPressCtrlToZoomHint: boolean;
  onWheel: (event: React.WheelEvent<HTMLDivElement>) => void;
}

class MapOverlayHintZoom extends React.Component<Props & StyledComponentProps> {
  public render() {
    const { classes, showPressCtrlToZoomHint } = this.props;
    return (
      <div
        onWheel={this.props.onWheel}
        className={classes && classes.container}
      >
        {this.props.children}

        <Fade in={showPressCtrlToZoomHint} timeout={500}>
          <div className={classes && classes.overlay}>
            <div className={classes && classes.text}>
              Strg+Scrollen zum Zoomen verwenden
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  container: {
    height: "100%",
    position: "relative",
    width: "100%",
  },
  overlay: {
    alignItems: "center",
    backgroundColor: "rgba(50, 50, 50, 0.7)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 1000,
  },
  text: {
    color: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: "30pt",
  },
});

export default withStyles(styles)(MapOverlayHintZoom);



// WEBPACK FOOTER //
// ./src/components/MapOverlayHintZoom.tsx